import { css } from 'styled-components'

const extendStylesDropdownChannel = css`
    width: 177px;
`

export {
    extendStylesDropdownChannel
}